export default class ResponsiveHelper {
    public static device = {
        isTouch: 'ontouchstart' in window,
        isSmartphone: function () { return window.matchMedia("screen and (max-width:599px)").matches; },
        isSmalltablet: function () { return window.matchMedia("screen and (min-width:600px) and (max-width:749px)").matches; },
        isTablet: function () { return window.matchMedia("screen and (min-width:750px) and (max-width:1024px)").matches; },
        isDesktop: function () { return window.matchMedia("screen (min-width:1024px)").matches; },
        isRetina: function () { return window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)").matches; },
        OS: {
            isAndroid: function () {
                return navigator.userAgent.indexOf("Edge") < 0 && navigator.userAgent.match(/Android/i) ? true : false;
            },
            isIOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            isWindowsOS: function () {
                return navigator.appVersion.indexOf("Win") !== -1;
            },
            isWindows: function () {
                return navigator.userAgent.indexOf("Edge") >= 0 || navigator.userAgent.match(/IEMobile/i) ? true : false;
            },
            isAny: function () {
                return ResponsiveHelper.device.OS.isAndroid() || ResponsiveHelper.device.OS.isIOS() || ResponsiveHelper.device.OS.isWindows();
            }
        }
    };

    public static onResize() {
        const self = this;
        this.setWrapMenu();
        this.setAccordion();
        this.retinaImages();

        window.addEventListener("resize", function (event) {
            self.setWrapMenu();
            self.setAccordion();
        });
    }

    public static retinaImages() {
        if (this.device.isRetina) {
            $("img.retina").attr("src", function () {
                return $(this).attr("src").replace(/(\.[\w\d_-]+)$/i, "@2x$1");
            });
        }
    }

    public static setWrapMenu() {
        $(".wrap-tap").hide();
        $(".main-menu .item").removeAttr("data-search").removeClass("hden");

        if (this.device.isTablet() || this.device.isSmalltablet() || this.device.isSmartphone()) {
            $(".exp").removeClass("show").slideDown();
            //$(".item").removeClass("show").slideDown();
            $(".main-menu").removeAttr("data-show");

            $(".button-exp").unbind().bind("click", function () {
                var section = $(this).attr("data-type");
                $(".exp[data-type=" + section + "]").toggleClass("show");
                $(".item[data-type=" + section + "]").toggleClass("show");
                $(".main-menu").removeAttr("data-show");
                $(".submenu, .submenu .exp").show();
            });

            $(".wrap-back").unbind().bind("click", function () {
                $(".exp").removeClass("show");
                $(".item").removeClass("show");
                $(".main-menu").attr("data-show", "true");
                $(".submenu-items .section-menu .item").slideUp();
                $(".submenu-items .section-menu .title").removeClass("active");
            });

            $(".wrap-menu").unbind().bind("click", function () {
                $(".main-menu").attr("data-show", "true").show();
                $(".main-menu .item").removeAttr("data-search").removeClass("hden");
                $(".wrap-tap").fadeIn();
                $(".main-menu  .expmenu .item").removeAttr("data-search");
                $(".exp").removeClass("show");
            });

            $(".wrap-tap").unbind().bind("click", function () {
                $(".main-menu").removeAttr("data-show");
                $(".exp").removeClass("show");
                $(".wrap-tap").fadeOut();
                $(".submenu-items .section-menu .item").slideUp();
                $(".submenu-items .section-menu .title").removeClass("active");
            });
        } else {
            $(".exp").removeClass("show").hide();

            $(".button-exp").unbind().bind("click", function () {
                var section = $(this).attr("data-type");
                if ($(".exp[data-type=" + section + "]" + ":visible").length) {
                    $(".exp[data-type=" + section + "]").slideUp().removeClass("show");
                    $(".item[data-type=" + section + "]").removeClass("show");
                } else {
                    $(".exp").slideUp();
                    $(".exp[data-type=" + section + "]").slideDown().addClass("show");
                    $(".item").removeClass("active").removeClass("show");
                    $(".item[data-type=" + section + "]").addClass("show");
                }
            });
        }
    }

    public static setAccordion() {
        var $item = $(".submenu-items .section-menu");

        if (this.device.isTablet() || this.device.isSmalltablet() || this.device.isSmartphone()) {
            $(".title", $item).unbind().bind("click", function () {
                var $itemCurrent = $(this).parent();
                $(".item", $item).not($(".item", $itemCurrent)).slideUp();
                $(".title", $item).not($(".title", $itemCurrent)).removeClass("active");
                $(".item", $itemCurrent).slideToggle();
                $(".title", $itemCurrent).toggleClass("active");
            });
        } else {
            $(".item", $item).slideDown();
            $(".title", $item).removeClass("active");
        }
    }
}